<template>
  <div class="content">
    <div class="bodycontent">
      <!-- 头部菜单 -->
      <div class="option">
        <div class="left">
          <el-button type="primary" @click="addRemark()">添加虚拟评价</el-button>
        </div>
        <div class="right">
          <span>
            <el-date-picker
              v-model="dateValue"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="setQueryTime()"
              style="width:360px">
            </el-date-picker>
          </span>
          <span>
            <el-select v-model="status" placeholder="状态">
            </el-select>
          </span>
          <span>
            <el-select v-model="type" placeholder="类型" clearable>
              <el-option label="真实" value="1"></el-option>
              <el-option label="虚拟" value="2"></el-option>
            </el-select>
          </span>
          <span>
            <el-input
              type="text"
              placeholder="请输入商品名"
              v-model="keyword"
              style="width:180px"
              clearable
            />
          </span>
          <span>
            <el-button type="primary" @click="search()">搜索</el-button>
          </span>
        </div>
      </div>
      <!-- 评论列表 -->
      <el-table :data="listData">
        <el-table-column label="商品">
          <template slot-scope="scope">
            <div class="row_line" v-if="scope.row.goods">
              <div class="goods_img">
                <img :src="scope.row.goods.image_id[0]" alt="">
              </div>
              <div class="goods_name">
                <div>{{scope.row.goods.name}}</div>
                <!-- <div><el-button type="text" size="small">查看详情</el-button></div> -->
              </div>
            </div>
            <div v-else>商品不存在</div>
          </template>
        </el-table-column>
        <el-table-column label="评价人">
          <template slot-scope="scope">
            <div class="row_line">
              <div class="user_img">
                <img :src="scope.row.user.headimgurl" alt="" v-if="scope.row.uid != '0'">
                <img :src="scope.row.headimg" alt="" v-else>
              </div>
              <div class="user_name">
                <div v-if="scope.row.uid != '0'">{{scope.row.user.username}}</div>
                <div v-else>{{scope.row.username}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="评分等级">
          <template slot-scope="scope">
            <div class="row_line">
              <el-rate
                v-model="scope.row.score"
                disabled
                score-template="{value}">
              </el-rate>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="评价内容">
          <template slot-scope="scope">
            <div class="row_line">
              <div class="goods_name">
                <div>{{scope.row.content}}</div>
                <div> <el-button type="text" size="small" @click="watchDetail(scope.row)">查看全部</el-button> </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="评价时间" prop="create_time"></el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            <div>{{scope.row.uid == 0? '虚拟评价':'真实评价'}}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80px">
          <template slot-scope="scope">
            <div>{{scope.row.show == 1? '显示':'隐藏'}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="changeShow(scope.row.id,1)" v-if="scope.row.show == 2">改为显示</el-button>
            <el-button type="text" @click="changeShow(scope.row.id,2)" v-if="scope.row.show == 1">改为隐藏</el-button>
            <el-button type="text" @click="delItem(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页按钮 -->
      <div class="Otherpage">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="showDetail" width="600px">
      <!-- 首次评论 -->
      <div class="detail_line" v-if="detail != {}">
        <div class="leftname">
          <div>{{detail.username||detail.user.name}}</div>
          <div class="time">{{detail.create_time}}</div>
        </div>
        <div class="center">
          <div>{{detail.content}}</div>
          <div class="img_list" v-if="detail.images">
            <img v-for="item in detail.images" :key="item" :src="item" alt="">
          </div>
        </div>
        <div class="rightname"></div>
      </div>
      <!-- 首次回复 -->
      <div class="detail_line" v-if="detail.reply_content">
        <div class="leftname">
          <div>商家回复</div>
          <div class="time">{{detail.reply_time}}</div>
        </div>
        <div class="center">
          <div>{{detail.reply_content}}</div>
          <div class="img_list" v-if="detail.reply_images">
            <img v-for="item in detail.reply_images" :key="item" :src="item" alt="">
          </div>
        </div>
        <div class="rightname">
        </div>
      </div>
      <!-- 追加评价 -->
      <div class="detail_line" v-if="detail.re_content">
        <div class="leftname">
          <div>追加评价</div>
          <div class="time">{{detail.re_content_time}}</div>
        </div>
        <div class="center">
          <div>{{detail.re_content}}</div>
          <div class="img_list" v-if="detail.re_images">
            <img v-for="item in detail.re_images" :key="item" :src="item" alt="">
          </div>
        </div>
        <div class="rightname"></div>
      </div>
      <!-- 追加回复 -->
      <div class="detail_line" v-if="detail.re_reply_content">
        <div class="leftname">
          <div>商家回复</div>
          <div class="time">{{detail.re_reply_time}}</div>
        </div>
        <div class="center">
          <div>{{detail.re_reply_content}}</div>
          <div class="img_list" v-if="detail.re_reply_images">
            <img v-for="item in detail.re_reply_images" :key="item" :src="item" alt="">
          </div>
        </div>
        <div class="rightname">
          
        </div>
      </div>
      <div class="revert_line">
        <el-input v-model="revert">
          <template slot="append">
            <el-button @click="revertComment">回复</el-button>
          </template>
        </el-input>
        
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { CommentList, DelComment, EditComment } from "@/api/comment"
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      status: "", //状态筛选
      type: "", //类型筛选 
      listData: [], //商户列表
      dateValue:[], //时间选择器
      keyword: "",
      page: 1,
      total: 0,
      showDetail:false, //评价详情
      detail: {
        user:{name:'空'},
        images:[]
      }, //评价详情
      revert: "", //商家回复
    };
  },
  mounted() {
    this.$store.commit("SET_STATE", "2");
    this.getData();
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("SET_STATE", "1");
    next();
  },
  methods: {
    getData(){
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        return_status: 1, //必填 回复状态检索 1需要首次回复 2需要追加回复
        start_time: this.start_time, //开始时间
        end_time: this.end_time, //结束时间
        type: this.type,
        keyword: this.keyword,
      }
      CommentList(data).then(res=>{
        console.log(res);
        this.listData = res.data;
        this.total = res.total;
      })
    },
    //时间选择
    setQueryTime(){
      if(this.dateValue){
        console.log(this.formatTime(this.dateValue[0]));
        console.log(this.formatTime(this.dateValue[1]));
        this.start_time = this.formatTime(this.dateValue[0]);
        this.end_time = this.formatTime(this.dateValue[1]);
      }
    },
    search() {
      this.page = 1;
      this.getData();
    },
    //添加虚拟评论
    addRemark(){
      this.$router.push('addComment');
    },
    //跳页
    handleCurrentChange(p){
      this.page = p;
      this.getData();
    },
    //查看详情
    watchDetail(data){
      this.detail = data;
      this.showDetail = true;
    },
    //编辑评论
    editItem(data){
      this.$router.push({path:'addComment',query:{item:data}});
    },
    //修改状态
    changeShow(cid,value){
      var data = {
        token: this.token,
        app_id: this.app_id,
        id: cid,
        show: value
      }
      EditComment(data).then(res=>{
        console.log(res)
        if(res.code == 200){
          this.$message({
            type: "success",
            message: "修改成功"
          })
          this.getData();
        }else{
          this.$message({
            type: "warning",
            message: res.msg
          })
        }
      })
    },
    //删除评论
    delItem(i){
      this.$confirm('确定删除？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var data = {
          token:this.token,
          app_id:this.app_id,
          id:i
        }
        DelComment(data).then(res=>{
          if(res.code == 200){
            this.$message({
              type:"success",
              message:"删除成功"
            })
            this.getData();
          }else{
            this.$message({
              type:"error",
              message:res.msg
            })
          }
        })
      }).catch();
    },
    revertComment(){
      console.log(this.revert);
      var data = {
        token: this.token,
        app_id: this.app_id,
        id: this.detail.id,
        reply_content: this.revert
      }
      EditComment(data).then(res=>{
        console.log(res)
        if(res.code == 200){
          this.$message({
            type: "success",
            message: "修改成功"
          })
          this.getData();
          this.showDetail = false;
        }else{
          this.$message({
            type: "warning",
            message: res.msg
          })
        }
      })
    },
    //时间格式化
    formatTime(time){
      var t = new Date(time);
      var y = t.getFullYear();
      var m = t.getMonth() + 1;
      var d = t.getDate();
      var h = t.getHours();
      var mm = t.getMinutes();
      var s = t.getSeconds();
      m = m < 10? '0'+m : m;
      d = d < 10? '0'+d : d;
      h = h < 10? '0'+h : h;
      mm = mm < 10? '0'+mm : mm;
      s = s < 10? '0'+s : s;
      return y + "-" + m + "-" + d + " " + h + ":" + mm + ":" + s;
    },
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 0px 27px 0;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    display: flex;
    flex-direction: column;
    .option {
      height: 79px;
      line-height: 79px;
      display: flex;
      .left {
        flex: 1;
      }
      .right {
        text-align: right;
        span{
          margin-left: 10px;
          .el-select{
            width:150px;
          }
        }
      }
    }
    // table
    .el-table {
      flex:1;
      box-shadow: 0 0 3px #f1f1f1;
      padding-left: 10px;
    }
    //表格中的商品内容
    .row_line{
      display: flex;
      .goods_img { //商品图片
        img{
          width:50px;
          height: 50px;
        }
      }
      .user_img{ //用户头像
        width:36px;
        height: 36px;
        border-radius: 18px;
        img{
          width:36px;
          height: 36px;
          border-radius: 18px;
        }
      }
      .goods_name{ //商品名
        flex:1;
        vertical-align: top;
        width:100px;
        margin-left: 10px;
        div{
          height: 25px;
          line-height: 25px;
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
        }
      }
      .user_name{ //用户名
        flex:1;
        height: 36px;
        line-height: 36px;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
      }
    }
    //分页
    .Otherpage {
      height: 34px;
      width: 200px;
      line-height: 34px;
    }
  }
  .detail_line{
    display: flex;
    margin-bottom: 20px;
    .time{
      padding:0 5px;
      color:#999;
    }
    .leftname{
      width:90px;
      margin-right: 10px;
      div{
        text-align: center;
        color:#aaa !important;
      }
    }
    .center{
      flex:1;
      .img_list{
        display: flex;
        flex-wrap: wrap;
        img{
          width: 80px;
          height: 80px;
        }
      }
    }
    .rightname{
      width:90px;
      margin-left: 10px;
      div{
        text-align: center;
        color:#aaa;
      }
    }
  }
  .revert_line{
    height: 45px;
  }
}
</style>
